import { useState } from 'react';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { TGetOffersResponse } from 'lendingApi/lapiOverrides.types';

type TTab = 'documentUpload' | 'instantOffer';
type TOffer = TGetOffersResponse['data']['offers'][number];

export type TUseOffersTabsValues = {
  currentView: TTab;
  handleTabChange: (tab: TTab) => void;
  indicativeOffer?: TOffer;
  instantOffer?: TOffer;
};

export const useOffersTabs = (): TUseOffersTabsValues => {
  const [currentView, setCurrentView] = useState<TTab>('documentUpload');
  const { offers } = useOffers({ getOffersEnabled: true });

  const indicativeOffer = offers?.find(
    (offer) => offer.offer_type === 'indicative',
  );
  const instantOffer = offers?.find(
    (offer) => offer.offer_type === 'confirmed',
  );

  const handleTabChange = (tab: TTab) => setCurrentView(tab);

  return { currentView, handleTabChange, indicativeOffer, instantOffer };
};
